import { useMemo } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { applySort } from "../backoffice.utils";
import { BookedQuote, bookedQuotesProvides } from "../providers/bookedQuotesProvider";
import { Student } from "../providers/studentsProvider";

export function useBookedQuotes(student: Student): {
  bookedQuotes: Array<BookedQuote>;
  selectedBookedQuote: BookedQuote;
  setSelectedBookedQuote: (bookedQuote: BookedQuote) => void;
} {
  const navigate = useNavigate();
  const { bookedQuoteId } = useParams();
  const { pathname } = useLocation();

  const bookedQuotes = useMemo(
    () => applySort(bookedQuotesProvides.getBookedQuotes(student), { field: "createdAt", order: "DESC" }),
    [student],
  );
  if (bookedQuotes.length === 0) {
    throw new Error(`Student ${student.id} has no booked quotes`);
  }
  const defaultBookedQuote =
    bookedQuotes.find((it) => it.id === student.activeOrMostRecentBookedTraining.quoteId) ?? bookedQuotes[0];
  const selectedBookedQuote = bookedQuotes.find((it) => it.id === bookedQuoteId) ?? defaultBookedQuote;
  return {
    bookedQuotes,
    selectedBookedQuote,
    setSelectedBookedQuote: (bookedQuote: BookedQuote) => {
      // Replace the bookedQuoteId in the URL with the selected one.
      // Warning: Avoid rebuilding the URL as it contains sub-routes for the selected tab and query params for the ReactAdmin list states (pagination and sorting).
      navigate(pathname.replace(/(booked-quotes\/)[0-9a-fA-F-]{36}/, `$1${bookedQuote.id}`));
    },
  };
}
